import React from 'react';
import { useParams } from 'react-router-dom';

// Hooks
import MovementProvider from '../../../hooks/movements/MovementProvider';
import useUser from '../../../hooks/user/useUser';

// Models
import { states, subTypes, types } from '../../../models/MovementEntity';

import MovementEdition from './main';

const MovementEditionView = ({ movementType = types.Ingress, movementSubType = subTypes.Reception }) => {
    const user = useUser();
    const { movementId } = useParams();
    const movement = {
        warehouseId: user.branch.warehouseId, 
        type: movementType,
        subType: movementSubType,
        state: states.Pending,
        branchCode: user.branch.code
    }

    return (
        <MovementProvider movement={movement}>
            <MovementEdition movementId={movementId} />
        </MovementProvider>
    )
}

export default MovementEditionView;